export type NccVariant = 'Generic' | 'Make' | 'MakeModel';

type NccMetaData = { make?: string; model?: string };

export function getNccVariant(metaData: NccMetaData | undefined): NccVariant {
  if (metaData?.make && metaData?.model) return 'MakeModel';
  if (metaData?.make) return 'Make';

  return 'Generic';
}

export function getNccHref(metaData: NccMetaData | undefined): string {
  if (metaData?.make && metaData?.model)
    return `/new/${metaData.make}/${metaData.model}`;
  if (metaData?.make) return `/new/${metaData.make}`;

  return '/new';
}
